import { Container, DropdownItem } from '@optimus-web/core';
import { lt } from '@mews/framework';

export const EmptyReservationListItem = ({ ...props }) => (
    <Container padding={['0', '0', '50']}>
        <DropdownItem
            {...props}
            key="empty-value"
            label={lt('ProcessPaymentLinkPaymentToReservationReservationSelectDropDownOptionEmptyValue')}
            // @ts-expect-error When editing existing values, it's easier to explicitely set empty value as `null` rather then transform `undefined` to `null`
            value={null}
        />
    </Container>
);
